import { render, staticRenderFns } from "./CircularProgress.vue?vue&type=template&id=96b627e8&scoped=true"
import script from "./CircularProgress.vue?vue&type=script&lang=js"
export * from "./CircularProgress.vue?vue&type=script&lang=js"
import style0 from "./CircularProgress.vue?vue&type=style&index=0&id=96b627e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b627e8",
  null
  
)

export default component.exports